goog.provide('el8.data.labOrderSets');

goog.require('el8.data.icd9Codes');
goog.require('el8.data.labOrderTests');
goog.require('el8.model.base');
goog.require('el8.service.urls');

el8.data.labOrderSets = (function() {

    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);
    _class.prototype.populate = function(spec) {
        spec = spec || {};
        if (spec.icd9s) {
            spec.icd9Ids = _.pluck(spec.icd9s, 'id');
            el8.data.icd9Codes.create(spec.icd9s);
        }
        if (spec.icd10s) {
            spec.icd10Ids = _.pluck(spec.icd10s, 'id');
            el8.data.icd10Codes.create(spec.icd10s);
        }
        if (spec.tests) {
            spec.testIds = spec.tests.map(function(a) { return a.id; });
            el8.data.labOrderTests.create(spec.tests);
        }
        this.parent.populate.call(this, spec);
    };

    _class.addStringProperty('name', true);
    _class.addProperty('testIds', true);
    _class.addIcd9s();
    _class.addIcd10s();
    _class.addIntProperty('labVendorId', true);
    _class.addStringProperty('vendorName');
    _class.addStringProperty('vendorDisplayName');
    _class.addStringProperty('vendorCompendium');

    // Deprecated
    _class.addIntProperty('vendorId', true);

    _class.prototype.getTests = function() {
        return this.getTestIds().map(function(id) {
            return el8.data.labOrderTests.getById(id);
        });
    };

    _class.prototype.asSoyMap = function() {
        var m = {};
        m['id'] = this.getId();
        m['name'] = this.getName();
        m['tests'] = this.getTests().map(function(t) { return t.getName(); });
        m['icd9Codes'] = this.getIcd9CodeObjs().map(function(d) { return d.getCode(); });
        m['icd10Codes'] = this.getIcd10CodeObjs().map(function(d) { return d.getCode(); });
        m['vendorId'] = this.getVendorId();
        m['vendorName'] = this.getVendorName();
        m['vendorDisplayName'] = this.getVendorDisplayName();
        m['vendorCompendium'] = this.getVendorCompendium();
        return m;
    };

    _class.prototype.asAutocompleteMap = function() {
        // to simulate "searching" order sets for emptyQueryData
        return {
            'id'          : this.getId(),
            'model_class' : 'LabOrderSet',
            'name'        : this.getName(),
            'test_names'  : this.getTests().map(function(t) { return t.getName(); }),
            'vendor_id'   : this.getVendorId(),
            'vendor_name' : this.getVendorName(),
            'vendor_display_name' : this.getVendorDisplayName(),
            'vendor_compendium' : this.getVendorCompendium()
        };
    };

    var that = new el8_EntitySet({
        model: function(spec) { return new _class(spec); },
        urlFn: function(id) {
            return el8.service.urls.get('labOrderSets', [id]);
        },
        urlLoad: function() {
            return el8.service.urls.get('labOrderSets');
        },
        deleteFn: function(item, callbackFn) {
            $.el8_ajax({
                type: 'DELETE',
                url: el8.service.urls.get('labOrderSets', [item.getId()]),
                success: callbackFn
            });
        }
    });

    return that;

})();

